export default __webpack_public_path__ + "static/media/stuffed_pepper.a2f8698f.jpg";